import {
    GET_BATCH_VOLUMES_SUCCESS,
    GET_BATCH_VOLUMES_FAIL,
    GET_BATCH_MEDIA_SUCCESS,
    GET_BATCH_MEDIA_FAIL,
    GET_BATCH_BULK_DENSITY_SUCCESS,
    GET_BATCH_BULK_DENSITY_FAIL,
    GET_VOL_AND_BD_AVERAGE_SUCCESS,
    GET_VOL_AND_BD_AVERAGE_FAIL,
    GET_BIOCHAR_MASS_SUCCESS,
    GET_BIOCHAR_MASS_FAIL,
    GET_BATCH_CARBON_CONTENT_SUCCESS,
    GET_BATCH_CARBON_CONTENT_FAIL,
    // GET_BIOCHAR_STORED_CARBON_SUCCESS,
    // GET_BIOCHAR_STORED_CARBON_FAIL,
    GET_QUENCH_TEAM_VIDEOS_SUCCESS,
    GET_QUENCH_TEAM_VIDEOS_FAIL,
    POST_QUENCH_TEAM_VIDEOS_SUCCESS,
    POST_QUENCH_TEAM_VIDEOS_FAIL,
    POST_BATCH_CARBON_CONTENT_SUCCESS,
    POST_BATCH_CARBON_CONTENT_FAIL,
    POST_BIOCHAR_STORED_CARBON_SUCCESS,
    POST_BIOCHAR_STORED_CARBON_FAIL,
    GET_CB_BATCH_DATA_SUCCESS,
    GET_CB_BATCH_DATA_FAIL,
    GET_CB_ADDITIONAL_BATCH_DATA_SUCCESS,
    GET_CB_ADDITIONAL_BATCH_DATA_FAIL,
    GET_CB_FIELD_NOTES_FAIL,
    GET_CB_FIELD_NOTES_SUCCESS,
    GET_CB_EQUIPMENT_TRANSPORT_SUCCESS,
    GET_CB_EQUIPMENT_TRANSPORT_FAIL,
    POST_CB_EQUIPMENT_TRANSPORT_SUCCESS,
    POST_CB_EQUIPMENT_TRANSPORT_FAIL,
    GET_CB_IGNITION_FUEL_SUCCESS,
    GET_CB_IGNITION_FUEL_FAIL,
    POST_CB_IGNITION_FUEL_SUCCESS,
    POST_CB_IGNITION_FUEL_FAIL,
    GET_QUENCH_TEAM_VIDEOS_DATA_SUCCESS,
    GET_QUENCH_TEAM_VIDEOS_DATA_FAIL,
    POST_QUENCH_TEAM_VIDEOS_DATA_SUCCESS,
    POST_QUENCH_TEAM_VIDEOS_DATA_FAIL
} from '../../actions/conservation-burns/types/conservation-burn-types';

const initialState = {
    loading: true,
    conversionData: [],
    batchVolumes: [],
    bulkDensity: [],
    volAndBdAverage: [],
    biocharMass: [],
    batchCarbonContent: [],
    biocharStoredCarbon: [],
    batchData: [],
    additionalBatchData: [],
    cbFieldNotes: [],
    ignitionFuel: [],
    equipmentTransport: [],
    quenchTeamVideos: [],
    quenchTeamVideosData: [],
};

export default function conservationBurnsReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case GET_BATCH_MEDIA_SUCCESS:
            return {
                ...state,
                loading: false,
                batchMedia: payload
            };
        case GET_BATCH_MEDIA_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_CB_BATCH_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                batchData: payload
            };
        case GET_CB_BATCH_DATA_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_CB_ADDITIONAL_BATCH_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                additionalBatchData: payload
            };
        case GET_CB_ADDITIONAL_BATCH_DATA_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_BATCH_VOLUMES_SUCCESS:
            return {
                ...state,
                loading: false,
                batchVolumes: payload
            };
        case GET_BATCH_VOLUMES_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_BATCH_BULK_DENSITY_SUCCESS:
            return {
                ...state,
                loading: false,
                bulkDensity: payload
            };
        case GET_BATCH_BULK_DENSITY_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_VOL_AND_BD_AVERAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                volAndBdAverage: payload
            };
        case GET_VOL_AND_BD_AVERAGE_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_BIOCHAR_MASS_SUCCESS:
            return {
                ...state,
                loading: false,
                biocharMass: payload
            };
        case GET_BIOCHAR_MASS_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_BATCH_CARBON_CONTENT_SUCCESS:
            return {
                ...state,
                loading: false,
                batchCarbonContent: payload
            };
        case GET_BATCH_CARBON_CONTENT_FAIL:
            return {
                ...state,
                loading: false
            };
        // case GET_BIOCHAR_STORED_CARBON_SUCCESS:
        //     return {
        //         ...state,
        //         loading: false,
        //         biocharStoredCarbon: payload
        //     };
        // case GET_BIOCHAR_STORED_CARBON_FAIL:
        //     return {
        //         ...state,
        //         loading: false
        //     };
        // case POST_VOL_AND_BD_AVERAGE_SUCCESS:
        //     return {
        //         ...state,
        //         loading: false
        //     };
        // case POST_VOL_AND_BD_AVERAGE_FAIL:
        //     return {
        //         ...state,
        //         loading: false
        //     };\
        case GET_QUENCH_TEAM_VIDEOS_SUCCESS:
            return {
                ...state,
                loading: false,
                quenchTeamVideos: payload
            };
        case GET_QUENCH_TEAM_VIDEOS_FAIL:
            return {
                ...state,
                loading: false,
            };
        case POST_QUENCH_TEAM_VIDEOS_SUCCESS:
            return {
                ...state,
                loading: false,
                quenchTeamVideos: payload
            };
        case POST_QUENCH_TEAM_VIDEOS_FAIL:
            return {
                ...state,
                loading: false,
            };
        case GET_QUENCH_TEAM_VIDEOS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                quenchTeamVideosData: payload
            };
        case GET_QUENCH_TEAM_VIDEOS_DATA_FAIL:
            return {
                ...state,
                loading: false,
            };
        case POST_QUENCH_TEAM_VIDEOS_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                quenchTeamVideosData: payload
            };
        case POST_QUENCH_TEAM_VIDEOS_DATA_FAIL:
            return {
                ...state,
                loading: false,
            };
        case POST_BATCH_CARBON_CONTENT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_BATCH_CARBON_CONTENT_FAIL:
            return {
                ...state,
                loading: false
            };
        case POST_BIOCHAR_STORED_CARBON_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case POST_BIOCHAR_STORED_CARBON_FAIL:
            return {
                ...state,
                loading: false
            };
        case GET_CB_FIELD_NOTES_SUCCESS:
            return {
                ...state,
                loading: false,
                cbFieldNotes: payload
            };
        case GET_CB_FIELD_NOTES_FAIL:
            return {
                ...state,
                loading: false,
            };
        case GET_CB_IGNITION_FUEL_SUCCESS:
            return {
                ...state,
                loading: false,
                ignitionFuel: payload
            };
        case GET_CB_IGNITION_FUEL_FAIL:
            return {
                ...state,
                loading: false,
            };
        case GET_CB_EQUIPMENT_TRANSPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                equipmentTransport: payload
            };
        case GET_CB_EQUIPMENT_TRANSPORT_FAIL:
            return {
                ...state,
                loading: false,
            };
        case POST_CB_IGNITION_FUEL_SUCCESS:
            return {
                ...state,
                loading: false,
                ignitionFuel: payload
            };
        case POST_CB_IGNITION_FUEL_FAIL:
            return {
                ...state,
                loading: false,
            };
        case POST_CB_EQUIPMENT_TRANSPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                equipmentTransport: payload
            };
        case POST_CB_EQUIPMENT_TRANSPORT_FAIL:
            return {
                ...state,
                loading: false,
            };
        default:
            return state;
    }
}